import { FirebaseDocRefType } from 'firebase/index'
import { CheckoutItemType } from 'types/checkoutItem'

const fetchCheckoutItemsByRef = (
  checkoutRef: FirebaseDocRefType,
  breadRefs: FirebaseDocRefType[]
): Promise<CheckoutItemType[]> => {
  return checkoutRef
    .collection('store_checkout_items')
    .get()
    .then((snapshots) => {
      const items: CheckoutItemType[] = []
      snapshots.forEach((snapshot) => {
        const item = snapshot.data() as CheckoutItemType
        // 生産店舗がsacri stationの画面を見ている場合
        if (breadRefs.length > 0 && breadRefs.every((breadRef) => breadRef.id !== item.bread_ref.id)) {
          return
        }
        item.checkout_id = snapshot.ref.parent.parent?.id
        item.checkout_item_ref = snapshot.ref
        items.push(item)
      })
      // 商品をあいうえお順にソート(数字 > 英字 > ひらがな > カタカナ > 漢字)
      items.sort((a, b) => (a.bread_name < b.bread_name ? -1 : 1))
      return items
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

export default fetchCheckoutItemsByRef
